import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getAllRoles, createSystemUser, updateSystemUser, getSystemUserByID } from "../../../../Services/User/SystemUserService";
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';

const CreateSystemUser = ({ isShow, close, type, editUserId }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rolesList, setRolesList] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedRoleError, setSelectedRoleError] = useState("");
  const usernameRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const emailRef = useRef(null);
  const [passwordShow, setPasswordShow] = useState(false);
  const passwordRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false); 
  const [status, setStatus] = useState();
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);

  useEffect(() => { 
    setShow(isShow)
  }, []); 
    useEffect(() => {
      const fetchRolesDetails = async () => {
        try {
          const response = await getAllRoles();
          if (response?.status) {
            setRolesList(response.data);
          } else {
            toast.error("Failed to fetch role details");
          }
        } catch (error) {
          console.error("Error fetching role details:", error);
          toast.error("Error fetching role details");
        }
      };
      if (isShow) {
        fetchRolesDetails();
      }
    }, [isShow]);
     useEffect(() => {
      const fetchUserDetails = async (editUserId) => {
        try {
          const response = await getSystemUserByID(editUserId);
          if (response?.status) {
            setName(response.data.name);
            setEmail(response.data.email);
            setMobileNo(response.data.mobile_number);
            setStatus(response.data.active)
            setSelectedRole(response.data.role_id)
          } else {
            toast.error("Failed to fetch feature details");
          }
        } catch (error) {
          console.error("Error fetching feature details:", error);
          toast.error("Error fetching feature details");
        }
      };
      if (type === "EDIT" && isShow) {
        fetchUserDetails(editUserId);
      }
    }, [type, editUserId, isShow]);
    const handlePasswordShow = (e) => {
        if (e.target.checked) {
            setPasswordShow(true)
        } else {
            setPasswordShow(false)
        }
    };
  const handleSubmit = async () => {
  
        if (!name.trim() || !email.trim() ||(type === "CREATE" && !password.trim()) || (showUpdatePassword && !password.trim())||(showUpdatePassword&& !password.trim()) || !mobileNo || !selectedRole) {
          setNameError(!name.trim());
          setEmailError(!email.trim());
          setPasswordError((type === "CREATE" && !password.trim()) || (showUpdatePassword && !password.trim()))
          setPasswordError(showUpdatePassword&& !password.trim())
          setMobileNoError(!mobileNo)
          setSelectedRoleError(!selectedRole)
  
          let object = [
          {
              key: name.trim(),
              ref: usernameRef.current,
          },
          {
              key: email.trim(),
              ref: emailRef.current,
          }, 
          {
              key: mobileNo.trim(),
              ref: mobileNumberRef.current,
          },
          {
              key: password.trim(),
              ref: passwordRef.current,
          }          
        ];

          for (let i = 0; i < object.length; i++) {
            if (!object[i].key) {
              object[i].ref?.focus();
              break;
            }
          }
          return;
        }
      setIsLoading(true);
      setIsDisabled(true);
  
      const insertData = {
        name: name.trim(),
        email: email.trim(),
        mobile_number: mobileNo,
        country_code: 91,
        role_id:selectedRole
      };
  
      try {
        let response;
        if (type === "CREATE") {
          insertData.password=password.trim()
          response = await createSystemUser(insertData);
        } else {
          if (showUpdatePassword) {
          insertData.password=password.trim()
          insertData.user_id=editUserId
          }
          insertData.user_id=editUserId
          insertData.status=status
          response = await updateSystemUser(insertData);
        }
        if (response.status) {
          toast.success(response.message);
          close();
        } else {
          toast.error(response.errorMessage);
        }
      } catch (error) {
        toast.error("Something went wrong!");
      } finally {
        setIsLoading(false);
        setIsDisabled(false);
      }}
  return ( 
    <Modal show={show} onHide={handleClose} dialogClassName="modal-xl" >
        <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add System User" : "Edit System User"}</h5>
        </Modal.Header>
        <Modal.Body>   
        <form className="row g-3">
              <div className="col-6 px-3">
              <label for="NewSystemUserName" className="form-label required"> Name</label>
               <input
                  id='name'
                  ref={usernameRef}
                  maxLength={35}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (nameError && e.target.value.trim() !== '') {
                      setNameError(false);
                    }
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                />
              <Form.Control.Feedback type="invalid" style={{ display: nameError ? 'block' : 'none' }}>
                User name is required
              </Form.Control.Feedback>
              </div>
              <div className="col-6 px-3">
                <label for="NewSystemUserEmail" className="form-label required"> Email</label>
                <input
                  id='email'
                  ref={emailRef}
                  maxLength={35}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (emailError && e.target.value.trim() !== '') {
                      setEmailError(false);
                    }
                  }}
                  type="email"
                  className="form-control"
                  placeholder="Enter Email"
                />
                <Form.Control.Feedback type="invalid" style={{ display: emailError ? 'block' : 'none' }}>
                  Email is required
                </Form.Control.Feedback>
              </div>
              <div className="col-6 px-3">
                <label for="NewMobileNo" className="form-label required">Mobile Number</label>
                <input
                  id='mobileNum'
                  ref={mobileNumberRef}
                  maxLength={10}
                  value={mobileNo}
                  onChange={(e) => {
                    setMobileNo(e.target.value);
                    if (mobileNoError && e.target.value.trim() !== '') {
                      setMobileNoError(false);
                    }
                  }}
                  type="number"
                  className="form-control"
                  placeholder="Enter Mobile Number"
                />
                <Form.Control.Feedback type="invalid" style={{ display: mobileNoError ? 'block' : 'none' }}>
                  Mobile number is required
                </Form.Control.Feedback>
              </div>
                <div className="col-6 px-3">
                <label for="NewRole" className="form-label required">Role</label>
                <select 
                  className="form-control"
                  value={selectedRole} 
                  onChange={(e) => {setSelectedRole(e.target.value) 
                    setSelectedRoleError(false)
                    }} 
                >
                <option value="" disabled={true} >Select Role</option>
                {rolesList.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.role}
                  </option>
                ))}
                </select>
                <Form.Control.Feedback type="invalid" style={{ display: selectedRoleError ? 'block' : 'none' }}>
                  Role is required
                </Form.Control.Feedback>
              </div>
          {type === "EDIT" &&
            <div className="col-6 px-3">
              <label htmlFor="UserStatus" className="form-label required">Status</label>
              <select
                id='UserStatus'
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="" disabled>Select status</option>
                <option value="true">Activate</option>
                <option value="false">Deactivate</option>
              </select>
              <div className="user-status invalid-feedback">
                Please select status.
              </div>
            </div>}
          {type !== "CREATE" &&
            <div className="col-6 px-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showUpdatePassword"
                  checked={showUpdatePassword}
                  onChange={(e) => setShowUpdatePassword(e.target.checked)}
                />
                <label htmlFor="showUpdatePassword" className="form-check-label">
                  Update Password
                </label>
              </div>
            </div>}
              {(type === "CREATE" || showUpdatePassword) && (
             <div className="col-6 px--6">
                <label htmlFor="NewSystemUserPassword" className="form-label required">Password</label>
                {!passwordShow?(<input
                  type="password"
                  className="form-control"
                  id="NewSystemUserPassword"
                  maxLength="35"
                  placeholder="Enter Password"
                  value={password}
                  ref={passwordRef}
                  onChange={(e) => {setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                      setPasswordError(false);
                  }}}
                />):(<input
                  type="text"
                  className="form-control"
                  id="NewSystemUserPassword"
                  placeholder="Enter Password"
                  maxLength="35"
                  value={password}
                  ref={passwordRef}
                  onChange={(e) => {setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                      setPasswordError(false);
                  }}}
                />)}
                <div className="col-9 px-1">
                    <div className="form-check">
                        <input
                            autoComplete="off"
                            className="form-check-input"
                            type="checkbox"
                            id="showPassword"
                            onChange={handlePasswordShow}
                            checked={passwordShow}
                        />
                        <label htmlFor="showPassword" className="form-check-label label-grey">
                            Show password
                        </label>
                      </div>
                </div>
                <Form.Control.Feedback type="invalid" style={{ display: passwordError ? 'block' : 'none' }}>
                    Password is required
                </Form.Control.Feedback>
              </div>   )}
              
            </form>
        </Modal.Body>
        <Modal.Footer>   
        <button
              type="button"
              className="btn btn-secondary"
              onClick={()=>handleClose()}
            >
              Close
            </button>
            <button
              id="createSystemUser"
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >Save</button>          
        </Modal.Footer>
      </Modal>
       
  );
};

export default CreateSystemUser;

 